import { render, staticRenderFns } from "./artificial-service-add.vue?vue&type=template&id=580fc811&scoped=true&"
import script from "./artificial-service-add.vue?vue&type=script&lang=js&"
export * from "./artificial-service-add.vue?vue&type=script&lang=js&"
import style0 from "./artificial-service-add.vue?vue&type=style&index=0&id=580fc811&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580fc811",
  null
  
)

export default component.exports